import { Stack } from '@mui/material';
import { PropsWithChildren } from 'react';

const FareListContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Stack padding={4} spacing={4} sx={{ '&:last-child': { marginBottom: 5 }, zIndex: 2 }}>
      {children}
    </Stack>
  );
};

export default FareListContainer;
